import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { ItemsList, TeamTile } from "@parkschannel/ui";
import { useAdvisorModal } from "../AdvisorModal";
import { NextAvatar } from "../../../NextAvatar";
export const TeamTileList = (param)=>{
    let { members  } = param;
    const { setAdvisor  } = useAdvisorModal();
    return /*#__PURE__*/ _jsx(ItemsList, {
        className: "grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-y-6 md:gap-x-[20px] lg:grid-cols-3 lg:gap-y-8 lg:gap-x-10",
        items: members,
        renderItem: (member)=>/*#__PURE__*/ _jsx(TeamTile, {
                onClick: ()=>setAdvisor(member),
                name: member.name,
                position: member.shortDescription,
                avatar: /*#__PURE__*/ _jsx(NextAvatar, {
                    src: member.avatar_key,
                    size: "xl",
                    className: "drop-shadow-xl"
                })
            })
    });
};
